// @flow
import loadStore from "./storeLoader";
import { configureStore, ActionType } from "bb-selection-picker";

/**
 * Define the inbound and outbound messages to/from this components store
 *
 * @type {{inbound: *[], outbound: *[]}}
 */
const config = {
  outbound: [
    ActionType.ADD_SELECTION,
    ActionType.REMOVE_SELECTION,
    ActionType.FETCH_MARKETS_SUCCESS,
    ActionType.FETCH_MARKETS_FAILURE
  ],
  inbound: [
    ActionType.RESET_SELECTIONS,
    ActionType.DISABLED_SELECTIONS,
    ActionType.ACTIVE_SELECTIONS,
    ActionType.LOAD_SELECTIONS,
    ActionType.UNLOAD_SELECTIONS,
    ActionType.FILTER_MARKETS,
    ActionType.USER_INTERACTION_ENABLED
  ]
};

/**
 * Creates the Selection Picker store
 *
 * @ignore
 */
const pickerStore = () =>
  loadStore(config, configureStore, [], {
    filterReducer: {
      categoryFilter: ["goals", "goal", "score", "result"]
    }
  });

export default pickerStore;



// WEBPACK FOOTER //
// ./src/stores/pickerStore.js